import { useCallback, useState } from 'react';
import { DEFAULT_PAGE, DEFAULT_COUNT } from './consts';

type PaginationState = {
  page: number;
  setPage: (page: number) => void;
  count: number;
  setCount: (count: number) => void;
};

/**
 * A very basic hook for setting up the pagination state.
 */
const usePaginationState = (
  initialPage: number = DEFAULT_PAGE,
  initialCount: number = DEFAULT_COUNT,
): PaginationState => {
  const [page, setPage] = useState<number>(initialPage);
  const [count, setCount] = useState<number>(initialCount);

  return {
    page,
    setPage,
    count,
    setCount: useCallback((newCount: number) => {
      setCount(newCount);
      // Reset the page when the count changes.
      setPage(DEFAULT_PAGE);
    }, [setCount]),
  };
};

export default usePaginationState;
